export default __webpack_public_path__ + "static/background-header-large-3dbebc16384566a48330acd6e6355762.png";